<template>
    <div class="modal is-active" :class="[{'modal-overflow': props.reviewEditorData}]" v-if="show">
        <div v-on:click="close" class="modal-background"></div>
        <div class="modal-card animated" :class="[{'has-width-auto': props.setWidthAuto}, {'modal-overflow': props.reviewEditorData}]">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ props.title }}</p>
                <p v-if="props.small_title" class="modal-card-small-title" v-html="props.small_title"></p>
            </header>
            <section class="modal-card-body has-text-centered editor-text">
                <!-- Setting up dynamic body content -->
                <p class="modal-body margin-bottom-10" v-html="props.body" v-if="!props.reportReview"></p>

                <p v-if="props.mergeBizProfile" class="modal-body margin-bottom-10">
                  The following will be moved from {{props.mergeBizProfile.secondaryBizName}} to {{props.mergeBizProfile.primaryBizName}}
                    <ul>
                      <li>{{props.mergeBizProfile.userCount}} users</li>
                      <li>{{props.mergeBizProfile.reviewCount}} reviews</li>
                    </ul>
                </p>

                <!-- Content editor -->
                <wysiwyg v-if="props.editor" v-model="props.editor.content"></wysiwyg>
                <p class="help is-danger has-text-weight-normal" v-if="props.editor && show_error">
                    {{props.editor.error}}
                </p>

                <!-- Edit review from Review Detail Begins -->
                <div class="columns flex-justify-end" v-if="typeof props.reviewMeta !== 'undefined' && typeof props.reviewMeta.replyType !== 'undefined'">
                  <div class="column has-text-right padding-right-0 is-narrow">
                    <input type="radio" :value="1" v-model="props.reviewMeta.replyType"> &nbsp;
                    Public reply
                  </div>
                  <div class="column has-text-right padding-right-0 is-narrow">
                    <input type="radio" :value="2" v-model="props.reviewMeta.replyType"> &nbsp;
                    Private reply
                  </div>
                </div> <!-- Edit review from Review Detail Ends -->

                <div style="width: 500px" v-if="props.reviewEditorData">

                  <div class="control margin-bottom-10">
                    <label class="label font-size-13">Rating:</label>
                    <FormRating tabindex="2" v-model="props.reviewEditorData.rating" :rating="props.reviewEditorData.rating" :spacer="true"></FormRating>
                  </div>

                  <div class="field margin-bottom-10">
                    <label for="review_title" class="label font-size-13 has-text-left">Title:</label>
                    <div class="control">
                      <input class="font-size-13" id="review_title" type="text" placeholder="Review title" v-model="props.reviewEditorData.title"/>
                    </div>
                  </div>

                  <div class="control margin-bottom-10 margin-top-10">
                    <label class="label font-size-13">Review:</label>
                    <wysiwyg class="font-size-13" v-model="props.reviewEditorData.content"></wysiwyg>
                  </div>
                  <p class="help is-danger has-text-weight-normal" v-if="show_error">
                    {{props.reviewEditorData.content.error}}
                  </p>
                  <!-- Response Time Section Begins -->
                  <div>
                    <p class="has-text-left"><b>Response Time</b></p>
                    <div class="columns">
                      <div class="column padding-left-0">
                        <SingleDatePicker format="DD-MM-YYYY" :value="props.reviewEditorData.responseTimestamp" @onSingleDateSelected="onDateSelected"/>
                      </div>
                      <div class="column is-2">
                        <input type="text" class="timestamp" v-model="props.reviewEditorData.hours" min="0" max="23">
                      </div>
                      <span class="is-flex flex-align-centre time-separator">:</span>
                      <div class="column is-2">
                        <input type="text" class="timestamp" v-model="props.reviewEditorData.min" min="0" max="59">
                      </div>
                    </div>
                  </div> <!-- Response Time Section Ends -->
                  <!-- NPSe Section Begins -->
                  <div class="margin-top-10">
                    <p class="has-text-left"><b>NPS Score</b></p>
                    <p class="has-text-left nps-msg">Update the NPS score by selecting from the dropdown list.</p>
                    <p class="has-text-left">
                      <div class="nps-rating-dropdown">
                        <div class="columns show-nps-section" @click="nps.dropdown = !nps.dropdown">
                          <div class="column is-paddingless">
                            <div
                              class="button button-dropdown is-flex"
                              aria-haspopup="true"
                              aria-controls="dropdown-menu"
                            >
                              {{props.reviewEditorData.npsRating}}
                            </div>
                          </div>
                          <div class="column is-paddingless has-text-right nps-caret">
                            <img src="/static/img/ic-down-arrow.svg" class="down-arrow" />
                          </div>
                        </div>
                        <div class="columns is-block dropdown-filter" :class="[{'modal-overflow': props.reviewEditorData}]" v-if="nps.dropdown">
                          <div class="column is-paddingless has-text-left options" v-for="index in 10" :key="index" @click="props.reviewEditorData.npsRating = index, nps.dropdown = false">{{index}}</div>
                        </div>
                      </div>
                    </p>
                  </div><!-- NPS Section Ends -->
                </div>

                <!-- business switcher -->
                <ul v-if="props.radioOptions">
                    <li v-for="option in props.radioOptions">
                        <nav class="level is-mobile">
                            <div class="level-left">
                                <div v-if="option.image" class="level-item">
                                    <figure class="media-left">
                                        <p class="image is-32x32">
                                            <img :src="option.image">
                                        </p>
                                    </figure>
                                </div>
                                <div class="level-item">
                                    <p class="has-text-weight-light" v-text="option.name"></p>
                                </div>
                            </div>
                            <div class="level-right">
                                <div class="level-item column-checkbox">
                                    <input type="radio" name="select_business" :value="option.id"
                                           v-model="radio_selection"/>
                                </div>
                            </div>
                        </nav>
                    </li>
                </ul>


                <!-- business switcher -->
                <template v-if="props.deleteBusiness">
                    <p class="has-text-centered has-text-danger margin-bottom-20" v-if="showDeleteBizReasonError">Please select a reason to delete business.</p>
                    <ul>
                        <li v-for="reason in deleteBizReason">
                            <nav class="level is-mobile">
                                <div class="level-left">
                                    <div class="level-item">
                                        <p class="has-text-weight-light">{{ reason }}</p>
                                    </div>
                                </div>
                                <div class="level-right">
                                    <div class="level-item column-checkbox">
                                        <input type="radio" name="biz_delete_reason" v-model="selectedDeleteBizReason" :value="reason"/>
                                    </div>
                                </div>
                            </nav>
                        </li>
                    </ul>
                </template>

                <!-- renders a collection of form elements -->
                <div v-if="props.textInputFields">
                    <div v-for="(fieldGroup, index) in props.textInputFields"
                         :class="['has-text-left', index, { 'margin-top-20':index > 0}]">
                        <div class="field">
                            <label v-if="fieldGroup.value" v-text="fieldGroup.value"></label>
                        </div>
                        <div v-for="(field, index) in fieldGroup.fields" class="field padding-left-0 padding-right-0">
                            <div v-if="field.fieldName === 'billingAddress'" class="control">
                                <vue-google-autocomplete
                                        id="address"
                                        ref="address"
                                        classname="input"
                                        :placeholder="`${field.fieldName}`"
                                        :country="['za']"
                                        v-on:placechanged="getAddressData">
                                </vue-google-autocomplete>
                            </div>
                            <div v-else class="control">
                                <input v-if="props.task === 'addEmailAddress'"
                                       type="text"
                                       @change="inputChange($event)"
                                       class="input"
                                       :id="field.fieldName"
                                       :name="field.fieldName"
                                       :placeholder="field.placeholder"/>
                                <input v-else
                                       type="text"
                                       @change="inputChange($event)"
                                       class="input"
                                       :id="field.fieldName"
                                       :name="field.fieldName"
                                       :value="field.value"
                                       :placeholder="field.placeholder"/>
                                <p class="help is-danger has-text-weight-normal" :ref="field.fieldName"></p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- mobile number renderer -->
                <div class="control margin-top-30"
                     v-if="props.form_element !== undefined && props.form_element.name === 'mobile_number'">
                    <input
                            type="text"
                            class="input"
                            :name="`${props.form_element.name}`"
                            v-model="mobile_number"
                            :placeholder="`${props.form_element.placeholder}`"/>
                    <p class="help is-danger has-text-weight-normal" v-if="show_error">
                        {{props.form_element.error_msg}}</p>
                </div>
                <!-- Confirmation modal post report review -->
                <div class="control has-text-centered margin-top-10" v-if="props.confirmationPostReportReview">
                  <p>You'll hear back from us within the next two business days.</p>
                  <p>While you're waiting, check out what happens when you <a :href="faqUrl" target="_blank">report a review</a>.</p>
                </div>
                <!-- End of confirmation modal -->
            </section>
            <!---Add new business model--->
          <div class="modal-card-body report-review" v-if="props.addNewBusinessByAdmin">
            <p class="modal-body">Business Name</p>
            <div class="addNewBizClass">
            <div class="">
              <label class="radio is-size-8 level margin-bottom-10">
                  <span class="biz_input">
                    <input
                      type="text"
                      name="businessName"
                      id="businessName"
                      v-model="newBizData.businessName"
                      class="color-58595b input is-size-7-touch"
                    />&nbsp;
                    <span class="help is-danger has-text-weight-normal" v-if="this.newBizDataError.business_error">{{this.newBizDataError.business_error}}</span>
                  </span>
              </label>
            </div>
            <p class="modal-body addNewBizSelectClass">Industry</p>
            <div :disabled="disableDropDown" :class="['control', {'disabled':disableDropDown}]">
              <div class="dropdown biz_select" :class="{'is-active' : show_dropdown}" @mouseleave="hideDropdown()">
                <div class="dropdown-trigger">
                  <button :disabled="disableDropDown" class="button-dropdown" aria-haspopup="true" @click.prevent="showDropdown()" aria-controls="dropdown-menu3">
                    <span :class="['is-size-6', {'disabled':disableDropDown}]" ref="industry_name" v-html="selectedIndustry"></span>
                    <span :class="['icon', 'is-small', {'disabled':disableDropDown}]"><i class="fas fa-angle-down" aria-hidden="true"></i></span>
                  </button>
                </div>
                <div class="dropdown-menu" role="menu">
                  <div class="dropdown-content is-paddingless">
                    <a v-for="industry in industries" href="#"
                       :ref="`${industry.id}`"
                       class="dropdown-item"
                       @click.prevent="selectIndustry(industry)"
                       v-html="industry.name">
                    </a>
                  </div>
                </div>
                <span class="help is-danger has-text-weight-normal" v-if="this.newBizDataError.industry_error">{{this.newBizDataError.industry_error}}</span>
              </div>
            </div>
            </div>
          </div>
           <!-----End add new business model------>
          <!-- Add new facebook page id modal -->
          <div class="modal-card-body report-review" v-if="props.addNewFacebookPageID">
            <p class="modal-body">Facebook Page ID</p>
            <div class="addNewBizClass">
              <div class="">
                <label class="is-size-8 level margin-bottom-10">
                  <span class="biz_input">
                    <input
                      type="text"
                      name="businessName"
                      id="facebookPageId"
                      v-model="facebookData.pageId"
                      class="color-58595b input is-size-7-touch"
                      @keypress="onlyNumber"
                      placeholder="Enter 15 Digit Facebook Page ID"
                      maxlength="15"
                    />&nbsp;
                    <span class="help is-danger has-text-weight-normal" v-if="this.facebookErrorData.error">{{this.facebookErrorData.error}}</span>
                  </span>
                </label>
              </div>
            </div>
          </div>
          <!--End add new facebook page id modal-->
            <!-- Report review modal -->
            <div class="modal-card-body report-review" v-if="props.reportReview">
              <p class="modal-body reporting-title">Why are you reporting this review?</p>
              <div class="report-reasons-section" v-for="reason in reportReasons">
                <label class="radio is-size-8 level margin-bottom-10">
                  <span>
                    <input
                      type="radio"
                      :value="reason.id"
                      name="reason"
                      v-model="reportForm.review_reason"
                    />&nbsp;
                    <span class="report-reasons-text"> {{defaultReportReasonsText[reason.reason]}} </span>
                  </span>
                </label>
              </div>
              <span class="help is-danger has-text-weight-normal" v-if="errors.review_reason">{{errors.review_reason[0]}}</span>
              <h6 class="modal-body margin-top-20 margin-bottom-10">Please give us more information to help us investigate:</h6>
              <div>
                <textarea class="textarea" cols="70" v-model="reportForm.report_reason"></textarea>
              </div>
              <span class="help is-danger has-text-weight-normal" v-if="errors.report_reason">{{errors.report_reason[0]}}</span>
            </div>
            <!-- End report review modal -->

            <!-- action buttons desktop -->
            <footer class="modal-card-foot is-hidden-mobile">
              <!-- Dual buttons with static Cancel button -->
              <div class="level-item has-text-centered" v-if="props.show_btns && !props.show_single_btn">
                <button class="button is-button-large has-button-medium is-button-dark-blue-outline" v-on:click="close" v-if="!props.secondary_btn_title">
                  CANCEL
                </button>
                <button class="button is-button-large has-button-medium is-button-dark-blue-outline" v-on:click="handleNavigation" v-if="props.secondary_btn_title">
                  {{props.secondary_btn_title}}
                </button>
                <button class="button is-button-large has-button-medium is-button-dark-blue" v-on:click="process">
                  {{props.btn_action_title }}
                </button>
              </div>
              <!-- Single button -->
              <div class="level-item has-text-centered" v-if="props.show_btns && props.show_single_btn">
                <button :class="[{'is-button-blue': props.blue_btn_class, 'is-button-blue-outline': props.overline_btn_class, 'is-loading': isProcessing}, 'button is-fullwidth-mobile']" v-on:click="process">
                  {{props.btn_action_title }}
                </button>
              </div>
            </footer>

            <!-- action buttons mobile -->
            <footer class="modal-card-foot is-hidden-tablet is-hidden-desktop">
              <!-- Dynamic primary button -->
              <div class="level-item has-text-centered" v-if="props.show_btns && !props.show_single_btn">
                <button class="button is-button-blue is-fullwidth-mobile" v-on:click="process">
                  {{props.btn_action_title }}
                  {{props.btn_action_title }}
                </button>
              </div>
              <!-- Dual buttons with static Cancel button -->
              <div class="level-item has-text-centered" v-if="props.show_btns && !props.show_single_btn">
                <button class="button is-button-blue-outline is-fullwidth-mobile" v-on:click="close" v-if="!props.secondary_btn_title">
                  CANCEL
                </button>
                <button class="button is-button-blue-outline is-fullwidth-mobile" v-on:click="handleNavigation" v-if="props.secondary_btn_title">
                  {{props.secondary_btn_title}}
                </button>
              </div>
              <!-- Single button -->
              <div class="level-item has-text-centered" v-if="props.show_btns && props.show_single_btn">
                <button :class="[{'is-button-blue': props.blue_btn_class, 'is-button-dark-blue-outline': props.overline_btn_class, 'is-loading': isProcessing}, 'button is-fullwidth-mobile']" v-on:click="process">
                  {{props.btn_action_title }}
                </button>
              </div>
            </footer>
        </div>
    </div>
</template>
<script>
  /* eslint-disable indent,no-new,no-undef,valid-jsdoc,no-useless-escape */
  import VueGoogleAutocomplete from 'vue-google-autocomplete'
  import Wysiwyg from './Wysiwyg.vue'
  import FormRating from './FormRating.vue'
  import misc from '../mixins/misc'
  import axios from 'axios'
  import qs from 'qs'
  import SingleDatePicker from './SingleDatePicker'

  export default {
    components: {
      Wysiwyg,
      VueGoogleAutocomplete,
      FormRating,
      SingleDatePicker
    },
    mixins: [
      misc
    ],
    data () {
      return {
        body: '',
        show: false,
        nps: {dropdown: false},
        errors: {
          review_reason: '',
          report_reason: ''
        },
        /**
         * properties include {
         * title - title of the modal window
         * body - content to display on the body of the modal
         * btn_action_title - name of the button other than cancel that needs to perform some processing in calling comp.
         * show_btns - flag to display buttons or not - good for display error messages.
         * }
         */
        props: {},
        reportReasons: [],
        defaultReportReasonsText: {
          'Spam': 'The review is spam or a scam',
          'Other': 'Other',
          'Defamatory': 'The review is defamatory',
          'False information': 'The review is false or contains false information',
          'Possible reassignment': 'The review is for a different business'
        },
        radio_selection: 0,
        inputTextBinds: {},
        mobile_number: '',
        is_mobile_number_valid: false,
        is_email_address_valid: false,
        show_dropdown: false,
        selectedIndustry: 'Select industry',
        selectedIndustryID: '',
        businessName: '',
        show_error: false,
        deleteBizReason: ['Spam', 'Duplicate business profile', 'Other'],
        industries: [],
        newBizData: {
          businessName: '',
          industryId: ''
        },
        newBizDataError: {
          business_error: false,
          industry_error: false
        },
        selectedDeleteBizReason: null,
        showDeleteBizReasonError: false,
        isProcessing: false,
        faqUrl: process.env.BLOG_URL + '/faqs',
        reportForm: {
          report_reason: null,
          review_reason: null
        },
        facebookData: {
            pageId: ''
        },
        facebookErrorData: {
            error: ''
        }
      }
    },
    updated () {
      // populate address field with props
      if (this.$refs.address !== undefined) {
        if (this.$refs.address[0] !== undefined) {
          this.$refs.address[0].update(this.props.textInputFields[0].fields[3].value)
        }
      }
    },
    created () {
      window.events.$on('modal', (props) => this.display(props))
      window.events.$on('onSingleDateSelected', (response) => { this.props.reviewEditorData.responseTimestamp = response.date })
      this.getReportReasons()
      this.getIndustries()
    },
    watch: {
      radio_selection () {
        this.props['selectedRadioOption'] = this.radio_selection
      }
    },
    methods: {
      onDateSelected (response) {
        this.props.reviewEditorData.responseTimestamp = response.date
      },
      /**
       * Callback handler for using Google Maps Static API
       * @param {object} addressData address data
       * @param {object} placeResultData placeresult data
       * @param {int} id id of location
       * @returns {null}
       */
      getAddressData: function (addressData, placeResultData, id) {
        this.inputTextBinds['billingAddress'] = placeResultData.formatted_address
        this.inputTextBinds['org_lng'] = addressData.longitude
        this.inputTextBinds['org_lat'] = addressData.latitude
      },
      /**
       * Displays notification message globally
       * @param {object} props an object of properties for modal to use for dynamic rendering of modal elements
       * @returns {void}
       */
      display (props) {
        this.show_error = false
        this.mobile_number = ''
        this.props = props

        if (props.radioOptions) {
          for (let i = 0; i < props.radioOptions.length; i++) {
            if (props.radioOptions[i]['selected']) {
              this.radio_selection = parseInt(props.radioOptions[i]['id'])
              break
            }
          }
        }
        if (props.textInputFields) {
          for (let fieldGroup of props.textInputFields) {
            for (let field of fieldGroup.fields) {
              const key = field.fieldName
              this.inputTextBinds[key] = field.value
            }
          }
        }
        this.show = true
        this.selectedDeleteBizReason = null
      },
      close () {
        this.show = false
        if (this.props.addNewFacebookPageID) {
          this.facebookData.pageId = ''
        }
        window.events.$emit('cancelOps', this.props)
        if (this.props.cleanBizModalData) {
          this.addNewBizCallAfterSucess()
        }
      },
      /**
       * Validates a collection of email addresses
       * @return {boolean}
       */
      validateEmailForms () {
        for (let field in this.inputTextBinds) {
          let value = this.inputTextBinds[field]
          if (value !== '') {
            // verify email
            this.is_email_address_valid = this.verifyEmail(value)
            if (!this.is_email_address_valid) {
              this.$refs[field][0].innerHTML = 'Email address is not valid.'
              return false
            } else {
              this.$refs[field][0].innerHTML = ''
            }
          }
        }
        return true
      },
      process () {
        this.show = false
        if (this.props.textInputFields) {
          if (this.props.task === 'addEmailAddress') {
            if (this.validateEmailForms()) {
              window.events.$emit(this.props.task, this.inputTextBinds)
              this.inputTextBinds = {}
            } else {
              this.show = true
            }
          } else {
            window.events.$emit(this.props.task, this.inputTextBinds)
          }
        } else if (this.props.form_element) {
          // validation for mobile number
          if (this.props.form_element.name === 'mobile_number') {
            this.is_mobile_number_valid = this.verifyMobileNumber(this[this.props.form_element.name])
            if (this.is_mobile_number_valid) {
              this.show_error = false
              this.props.form_element.value = this[this.props.form_element.name]
              window.events.$emit(this.props.task, this.props)
            } else {
              this.show = true
              this.show_error = true
              this.props.form_element.error_msg = 'Please provide valid mobile number'
            }
          }
        } else if (this.props.editor) {
          if (this.props.editor.content) {
            this.show_error = false
            window.events.$emit(this.props.task, this.props)
          } else {
            this.show = true
            this.show_error = true
            this.props.editor.error = 'Please provide content'
          }
        } else if (this.props.deleteBusiness) {
            if (this.selectedDeleteBizReason === null) {
                this.show = true
                this.showDeleteBizReasonError = true
                setTimeout(() => { this.showDeleteBizReasonError = false }, 3000)
                return
            }
            axios.delete(`/${this.props.businessSlug}/delete-business`, {data: {bizDeleteReason: this.selectedDeleteBizReason}})
                .then((response) => {
                    this.recacheOnBizModified([this.props.businessSlug], [response.data.industry.slug])

                    flash(`Business deleted successfully.`, 'is-success')
                    if (localStorage.getItem('bizFilterList')) {
                      let query = JSON.parse(localStorage.getItem('bizFilterList'))
                      let filters = qs.stringify(query)
                      localStorage.removeItem('bizFilterList')
                      this.$router.push(`/businesses?${filters}&flash=true`)
                    } else {
                      this.$router.push(`/businesses?flash=true`)
                    }
                })
                .catch(({response}) => {
                    if (response.data.success === false) {
                        flash(response.data.message, 'is-danger')
                    } else {
                        flash('You are not authorized to view this resource.', 'is-danger')
                    }
                    this.is_loading = false
                    this.fetching_data = false
                })
        } else if (this.props.reportReview) {
            this.show = this.isProcessing = true
            // If event called for reporting review
            this.reportForm.businessSlug = localStorage.getItem('org_slug')
            axios.post(`/report-review/${this.props.permalink}`, this.reportForm)
            .then(({data}) => {
              this.show = this.isProcessing = false
              Object.assign(this.reportForm, {report_reason: '', review_reason: ''})
              Object.assign(this.errors, {report_reason: '', review_reason: ''})
              window.events.$emit(this.props.task, data)
            })
            .catch((errors) => {
              this.isProcessing = false
              this.errors = errors.response.data
            })
        } else if (this.props.addNewBusinessByAdmin) {
             /** validate create new biz by admin and make a api call to crete new one**/
            if (this.newBizData.businessName === '') {
              this.show = true
              this.newBizDataError.business_error = 'Please Enter Business Name.'
              setTimeout(() => { this.newBizDataError.business_error = false }, 3000)
              return
            }
            /** If business name containing any special character apart from space/dash **/
            if (this.newBizData.businessName !== '') {
              let regex = /[a-zA-Z0-9]/
              if (!regex.test(this.newBizData.businessName)) {
                this.show = true
                this.newBizDataError.business_error = 'Cannot save business with special characters in the name.'
                setTimeout(() => {
                  this.newBizDataError.business_error = false
                }, 3000)
                return
              }
            }
            if (this.newBizData.industryId === '') {
              this.show = true
              this.newBizDataError.industry_error = 'Please Select Industry for this Business.'
              setTimeout(() => { this.newBizDataError.industry_error = false }, 3000)
              return
            }
            return axios.post('/businesses/create-new-biz', {
              business_name: this.newBizData.businessName,
              industry_id: this.newBizData.industryId
            }).then(({data}) => {
              this.addNewBizCallAfterSucess()
              flash(`Business has been successfully added.`, 'is-success')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'success',
                  'messageName': 'Successfully business added.',
                  'displayedMessage': 'Business has been successfully added.'
                }
              })
            }).catch((error) => {
              this.show = false
              let msg = error.response.data
               if (error.response.status === 422) {
                 msg = []
                 for (let field in error.response.data) {
                   msg.push(error.response.data[field][0])
                 }
               }
              flash(msg, 'is-danger')
              dataLayer.push({
                'userMessage': {
                  'messageType': 'error',
                  'messageName': 'Failed to create new business,please try again later',
                  'displayedMessage': msg
                }
              })
            })
        } else if (this.props.addNewFacebookPageID) {
            // validate facebook page id
          if (this.facebookData.pageId === '' || (this.facebookData.pageId.length !== 15 && this.facebookData.pageId)) {
              this.show = true
              this.facebookErrorData.error = 'Please Enter 15 Facebook Page ID.'
              return
          }
          axios.post(`/${this.props.businessSlug}/add-facebook-page-id`, {
            facebookPageId: this.facebookData.pageId
          })
          .then(({data}) => {
            this.displaySuccessMsg(`Facebook Page ID has been successfully added.`, 'Successfully Facebook page tab added.')
            window.open(`http://www.facebook.com/dialog/pagetab?app_id=${process.env.FACEBOOK_APP_ID}&next=${process.env.API_URL}/${this.props.businessSlug}/consumer/check`)
          }).catch((error) => {
            this.displayErrMsg(error, 'Failed to add new facebook page tab, please try again later', 'Facebook Page ID has already been added for this business')
          })
        } else {
            window.events.$emit(this.props.task, this.props)
        }
      },
      inputChange (event) {
        this.$emit('changed', event.target)
        this.inputTextBinds[event.target.name] = event.target.value
      },
    /***
     * common function to null all values after sucess call
     */
      addNewBizCallAfterSucess () {
        this.newBizData.businessName = ''
        this.newBizData.industryId = ''
        this.selectedIndustry = 'Select industry'
        this.newBizDataError.industry_error = false
        this.newBizDataError.business_error = false
      },
      /**
        * Event for navigating to desired route
        * @return {void}
      */
      handleNavigation () {
        this.close()
        if (this.props.keepMaskedDataPublic) {
          window.events.$emit('keepMasked', this.props)
        }
        window.events.$emit('navigateTowardsRoute', this.props.to_path)
      },
      /**
       * Get list of report reasons
       * @returns {void}
       */

      getReportReasons () {
        axios.get('report-reasons')
          .then(({data}) => {
              this.reportReasons = data
          })
      },
       /*
       * Hide industry dropdown on mouse removal
       */
      hideDropdown () {
        this.show_dropdown = false
      },
      /**
       * Show dropdown for indusrty list
       */
      showDropdown () {
        this.show_dropdown = !this.show_dropdown
        },
      /**
       * Select industry from dropdown
       */
      selectIndustry (industry) {
        this.newBizData.industryId = industry.industry_id
        this.selectedIndustry = industry.name
        this.show_dropdown = false
        },
      /**
      * Make a api call to get all industries list
      * @return {void}
      */
      getIndustries () {
        axios.get('/search/industries/')
        .then(({data}) => {
          this.industries = data
        })
        .catch(() => {
          flash('Error retrieving the list of industries! Contact the System\'s Administrator.', 'is-danger')
        })
        }
    },
    computed: {
      disableDropDown () {
        return this.newBizData.businessName === ''
      }
    }
  }
</script>
<style scoped>
    .modal-card-head, .modal-card-foot {
        border-bottom: none;
        border-right: none;
        border-left: none;
        border-radius: 0;
        text-align: center;
        background-color: #fff;
        display: block;
    }

    .modal-card-foot {
        border-top: none;
    }

    .modal-card-body {
        text-align: left;
        background-color: #fff;
        font-size: .9em;
        padding: 0 20px;
    }

    .modal-card-head {
        border-top: 5px solid #1261a0;
        padding-top: 40px;
    }

    @media screen and (min-width: 768px), print {
        .modal-content, .modal-card {
            margin: 0 auto;
            max-height: calc(100vh - 40px);
            width: 400px;
        }
    }

    .level-item {
        display: block;
    }

    .modal-card-title {
        color: #1261a0;
        font-weight: bold;
    }

    section.modal-card-body > ul > li {
        margin-left: 32px;
        margin-right: 32px;
    }

    section.modal-card-body > ul > li {
        padding-bottom: 25px;
    }

    section.modal-card-body > ul > li:not(:last-child) {
        border-bottom: 1px solid #cccccc;
    }

    section.modal-card-body > ul > li:not(:first-child) {
        padding-top: 25px;
    }

    .column-checkbox {
        padding-top: 0 !important;
    }

    input[type="radio"]:checked {
        background-color: #30AAE1;
        border: 1px solid #30AAE1;
    }

    input[type="text"] {
        border-radius: 0;
        box-shadow: none !important;
        border: 1px solid #dbdbdb;
        display: inline-flex;
        font-size: 1rem;
        height: 2.25em;
        justify-content: flex-start;
        line-height: 1.5;
        padding-bottom: calc(0.375em - 1px);
        padding-left: calc(0.625em - 1px);
        padding-right: calc(0.625em - 1px);
        padding-top: calc(0.375em - 1px);
        position: relative;
        vertical-align: top;
        background-color: white;
        max-width: 100%;
        width: 100%;
    }

    input[type="radio"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        display: inline-block;
        width: 18px;
        height: 18px;
        padding: 3px;
        background-clip: content-box;
        border: 1px solid #d5d3d3;
        background-color: #fff;
        border-radius: 50%;
        vertical-align: middle;
    }

    .level-left > .level-item:first-child {
        margin-right: 0 !important;
        margin-left: 20px;
    }

    @media screen and (max-width: 767px) {
        .modal-background {
            background-color: #fff;
        }

        .modal-card-head {
            border-top: none;
            padding-top: 0;
        }
        .report-reasons-text{
          font-size: 10px;
        }
    }

    @media screen and (min-width: 411px){
      .report-reasons-text{
        font-size: 13px;
      }
    }
    @media screen and (min-width: 320px){
      .report-reasons-text{
        font-size: 9px;
      }
    }
    @media screen and (min-width: 375px){
      .report-reasons-text{
        font-size: 11px;
      }
    }
    @media screen and (min-width: 360px){
      .report-reasons-text{
        font-size: 10px;
      }
    }
    @media screen and (min-width: 400px){
      .report-reasons-text{
        font-size: 13px;
      }
    }
    .trix-start {
        margin-bottom: 0;
    }

    .modal-card-small-title
    {
      margin-top: 10px;
    }

    .font-size-13
    {
      font-size: 13.6px !important;
    }
    span.biz_input,span.biz_input input {
      width: 100%;
    }

    .dropdown.biz_select,.dropdown.biz_select div {
      width: 100% !important;
      border-radius: 5px;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: 0px;
    }
    .dropdown.biz_select .dropdown-trigger {
      display: block !important;
    }

    .dropdown.biz_select {
      display: block;
    }
    .dropdown.biz_select .dropdown-menu {
      overflow-y: scroll;
      height: 200px;
      position:relative;
    }
    .addNewBizClass {
      margin-top: 10px;
    }
    .addNewBizSelectClass{margin:10px 0px;}
    .dropdown.biz_select {
      margin-bottom: 20px;
    }
    .report-reasons-section{
      margin-left: 4%;
    }
    .reporting-title{
      padding-bottom: 10px;
    }
    .margin-top-10 a {
      text-decoration: underline;
    }
    section.editor-text .trix-start {
      text-align: left !important;
    }

    /* Review Edit Modal Begins */
    .nps-msg {
      font-size: 11px;
    }
    .nps-score-select {
      width: 12%;
      color: #58595b;
      margin: 2% 0 3% 0;
      padding: 7px 10px;
      outline: none;
      font-size: 11px;
      background: #fff;
      border-radius: 2px;
      border: solid 1px rgba(88, 89, 91, 0.32);
    }
    .timestamp {
      font-size: 11px !important;
      padding: 18px 12px !important;
    }
    select option {
      padding: 20px !important;
      color: red;
      height: 20px;
    }
    .nps-rating-dropdown {
      width: 12%;
      margin: 2% 0 0;
    }
    .nps-rating-dropdown .show-nps-section {
      position: relative;
      margin-bottom: 5%;
    }
    .nps-rating-dropdown .show-nps-section .nps-caret {
      top: 9px;
      right: 5px;
      position: absolute;
    }
    .nps-rating-dropdown .button-dropdown {
      padding: 5px 0 2px 9px;
    }
    .nps-rating-dropdown .dropdown-filter {
      color: #8A8C91;
      /*margin-top: 5%;*/
    }
    .nps-rating-dropdown .options {
      cursor: pointer;
      padding: 8px 12px !important;
      border: solid 1px rgba(88, 89, 91, 0.32);
    }

    .modal.is-active.modal-overflow {
      overflow-y: scroll;
    }
    .modal-card.animated.has-width-auto.modal-overflow {
      overflow: initial;
      position: relative;
      height: 670px;
    }
    .columns.is-block.dropdown-filter.modal-overflow {
        /*width: 11%;
        z-index: 9;
        position: absolute;
        top: 87%;
        background-color: #fff;*/
    }
    .time-separator {
      height: 58px;
      align-items: center;
    }
    /* Review Edit Modal Ends */
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue